// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log("Vite ⚡️ Rails");

// Import jQuery (required for some legacy components)
import $ from "jquery";
window.jQuery = $;
window.$ = $;

// Import all of Bootstrap's JS (Popper is automatically imported)
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;

// Import our custom CSS (which imports Bootstrap SCSS)
import "../../assets/stylesheets/application.scss";

// Import Leaflet CSS
import "leaflet/dist/leaflet.css";

// Import and configure Stimulus
import { Application } from "@hotwired/stimulus";
import { registerControllers } from "../controllers";

const application = Application.start();
application.debug = false;
window.Stimulus = application;

registerControllers(application);

// Import all ActionCable channels
import.meta.glob("../channels/**/*_channel.js", { eager: true });

// Import layout-specific scripts
import "../layouts/admin";

// Import TinyMCE
import "./tinymce";

import "../packs/informing/form";
import "../packs/user_profile/device_management";
import "../packs/notification_logs/index";
import "../packs/poster/poster_form_validation";
import "../packs/transport/maps";
import "../packs/transport/stops_map";
import "../packs/utility/outages_map";
import "../packs/electricity/schedule_image";
import "../packs/street/geometry_map";

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log(
  "Visit the guide for more information: ",
  "https://vite-ruby.netlify.app/guide/rails",
);

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
